import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/rkf6zAkTmHwixLQAqgKWD9/Captura_de_pantalla_2026-02-08_a_las_1.33.17_a._m..png',
  alt: 'Tomo 1 — Las 3000 palabras más usadas en inglés'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iVv8DLGp3BHVmf9Wq5GSTm/Captura_de_pantalla_2026-02-08_a_las_1.33.29_a._m..png',
  alt: 'Método 80/20 — Las palabras que realmente se usan'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iZYoqVx6tSrp27MFVtYx21/Captura_de_pantalla_2026-02-08_a_las_1.33.48_a._m..png',
  alt: 'Tomo 2 — Expresiones para un inglés fluido'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ksPsrpVk9ah8x5MF6yMLk1/Captura_de_pantalla_2026-02-08_a_las_1.34.07_a._m..png',
  alt: 'Contenido interior — Reacciones rápidas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nqALJqEv89BBDBcswSZJVs/Captura_de_pantalla_2026-02-08_a_las_1.34.34_a._m..png',
  alt: 'Contenido interior — 12 Expresiones para Ayudar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6LXxRLZzArQD1boLPGYvqu/Captura_de_pantalla_2026-02-08_a_las_1.34.19_a._m..png',
  alt: 'Tomo 4 — Guía de expresiones comunes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xAwmKmxLAQA7xr84H4Hx7y/Captura_de_pantalla_2026-02-08_a_las_1.38.13_a._m..png',
  alt: 'Tomo 3 — Aprende inglés cantando'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iKPGEM3X8LFQpr9LnQHQmq/Captura_de_pantalla_2026-02-08_a_las_1.38.24_a._m..png',
  alt: 'Cancionero — Tabla de contenidos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gN5njoh3WsfKDNkQQrfRLx/Captura_de_pantalla_2026-02-08_a_las_1.38.56_a._m..png',
  alt: 'Tomo 5 — Short Stories in English'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aAmdNtQ1GjUoYL242JJTi7/Captura_de_pantalla_2026-02-08_a_las_1.39.06_a._m..png',
  alt: 'Historias cortas — Tabla de Contenidos'
}];
export function MaterialPreview() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  // Preload all images on mount
  useEffect(() => {
    images.forEach(img => {
      const preload = new Image();
      preload.src = img.src;
    });
  }, []);
  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 350);
  }, [isTransitioning]);
  const paginate = useCallback((dir: number) => {
    if (isTransitioning) return;
    setCurrent(prev => {
      const next = prev + dir;
      if (next < 0) return images.length - 1;
      if (next >= images.length) return 0;
      return next;
    });
    setIsTransitioning(true);
    setTimeout(() => setIsTransitioning(false), 350);
  }, [isTransitioning]);
  return <section className="w-full bg-white py-8 md:py-14 px-4" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-2" data-id="element-97">
          Mirá el material <span className="text-[#FF6B00]" data-id="element-98">por dentro</span>
        </h2>
        <p className="text-[#4A4A5A] text-center mb-6" data-id="element-99">
          Así se ve lo que vas a recibir. Sin sorpresas.
        </p>

        <div className="relative" data-id="element-100">
          {/* Carousel container — fixed aspect ratio prevents layout shifts */}
          <div className="relative overflow-hidden rounded-xl bg-[#F8F9FA] aspect-[3/4]" data-id="element-101">
            {images.map((img, index) => <img key={index} src={img.src} alt={img.alt} className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-300 ease-in-out ${index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} draggable={false} data-id="element-102" />)}

            {/* Counter badge */}
            <div className="absolute top-3 right-3 z-20 bg-[#1A1A2E]/70 text-white text-xs font-semibold px-3 py-1 rounded-full" data-id="element-103">
              {current + 1} / {images.length}
            </div>
          </div>

          {/* Navigation arrows */}
          <button onClick={() => paginate(-1)} className="absolute left-2 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/90 hover:bg-white rounded-full shadow-md flex items-center justify-center cursor-pointer transition-colors" aria-label="Anterior" data-id="element-104">
            <ChevronLeftIcon className="w-5 h-5 text-[#1A1A2E]" data-id="element-105" />
          </button>
          <button onClick={() => paginate(1)} className="absolute right-2 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/90 hover:bg-white rounded-full shadow-md flex items-center justify-center cursor-pointer transition-colors" aria-label="Siguiente" data-id="element-106">
            <ChevronRightIcon className="w-5 h-5 text-[#1A1A2E]" data-id="element-107" />
          </button>
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-108">
          {images.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`h-2.5 rounded-full cursor-pointer transition-all duration-200 ${index === current ? 'bg-[#FF6B00] w-6' : 'bg-[#D1D5DB] hover:bg-[#9CA3AF] w-2.5'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-109" />)}
        </div>
      </div>
    </section>;
}